import { ValidateJSModel } from 'forms/shared/types';
import { hasYesOrNo } from 'models/validate';
import { isPVQForm } from 'helpers/form';
import { setToStartOfMonth } from 'helpers/date';
import { DEFAULT_LATEST } from 'constants/dateLimits';
import { SubstanceAlcoholNegativeModel } from './types';
import substanceAlcoholNegativeItemValidator from './validators/item';

const substanceAlcoholNegativeValidator: ValidateJSModel<SubstanceAlcoholNegativeModel> = {
  HasImpacts: { presence: true, hasValue: { validator: hasYesOrNo } },
  List: (value, attributes, attributeName, options) => {
    if (!isPVQForm(options?.formType) && attributes?.HasImpacts && attributes?.HasImpacts.value === 'Yes') {
      return { presence: true, accordion: { validator: substanceAlcoholNegativeItemValidator } };
    }
    return {};
  },
  Comments: {},
  SummaryComments: {},
  Impact: (value, attributes, attributeName, options) => {
    if (!isPVQForm(options?.formType)) {
      return {};
    }

    if (attributes?.HasImpacts && attributes?.HasImpacts.value === 'Yes') {
      return { presence: true, hasValue: true };
    }
    return {};
  },
  WhenAffected: (value, attributes, attributeName, options) => {
    if (!isPVQForm(options?.formType)) {
      return {};
    }

    const { applicantBirthdate } = options;

    if (attributes?.HasImpacts && attributes?.HasImpacts.value === 'Yes') {
      return {
        presence: true,
        daterange: { earliest: setToStartOfMonth(applicantBirthdate), latest: DEFAULT_LATEST },
      };
    }
    return {};
  },
};

export default substanceAlcoholNegativeValidator;
